module.exports = __webpack_public_path__ + "img/43.785d896f.jpg";